<script>
import deepLink from '@/mixins/deeplink.js'
import GTM_CONSTANTS from '@constants/google-tag-manager'

export default {
  name: 'Confirmation',
  components: {},
  mixins: [deepLink()],
  props: {},
  data() {
    return {
      rating: 5,
    }
  },
  computed: {
    app() {
      return app || this.app // eslint-disable-line
    },
  },
  methods: {
    closeWebview() {
      this.$ga.event({
        eventCategory: 'user-actions',
        eventAction: 'ation-rating',
        eventLabel: 'rate-webcall',
        eventValue: this.rating,
      })
      this.$gtm.trackEvent({
        event: GTM_CONSTANTS.LOG_EVENT,
        noninteraction: 'RATE_SUPPORT',
        payload: this.rating,
        eventType: 'RATE_SUPPORT',
      })
      this.app.endCall()
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <div :class="$style.container__content">
      <!-- <img
        class="container__logo"
        src="@assets/images/checkIcon.png"
      alt="check-icon">-->
      <h2>{{ $t('WIDGETS.COMMON.RATE_US') }}</h2>

      <v-rating
        :class="$style.container__contentRating"
        v-model="rating"
        color="yellow darken-3"
        background-color="grey darken-1"
        empty-icon="$vuetify.icons.ratingFull"
        half-increments
        hover
      />
    </div>
    <BaseButton
      :class="$style.container__button"
      full
      alter
      @click="closeWebview"
    >{{ $t('WIDGETS.COMMON.UNDERSTOOD') }}</BaseButton>
  </div>
</template>


<style lang="scss" scoped module>
@import '@design';

.container {
  position: relative;
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  justify-content: center;
  min-height: 100vh;

  &__content {
    padding: 4rem;
    img {
      max-width: 7rem;
      max-height: 7rem;
      margin-bottom: 0.8rem;
    }

    h2 {
      margin-bottom: 1.5rem;
    }
    p {
      @extend %typography-large;

      margin: 0;
      font-weight: 420;
    }

    span {
      font-weight: bold;
      color: $primary-green;
    }
  }

  // &__button {
  //   position: absolute;
  //   bottom: 2rem;
  // }
}
</style>
